import {create} from 'apisauce';
import qs from 'qs';
import {
  AlertService,
  AmbientWeatherService,
  AuthService,
  BillingService,
  DavisService,
  EcowittService,
  ForecastMapService,
  GoogleService,
  MyAcuriteService,
  NetatmoEnergyService,
  NetatmoWeatherService,
  UserService,
  WeatherService,
  WeatherflowService,
  WundergroundService,
} from './actions';
import * as ErrorCode from './errorCodes';

const apiClient = (url_root: string) =>
  create({
    baseURL: `${url_root}/api`,
    timeout: 60000,
    paramsSerializer: function (params) {
      return qs.stringify(params, {arrayFormat: 'repeat'});
    },
  });

export {
  AlertService,
  AmbientWeatherService,
  AuthService,
  BillingService,
  DavisService,
  EcowittService,
  ErrorCode,
  ForecastMapService,
  GoogleService,
  MyAcuriteService,
  NetatmoEnergyService,
  NetatmoWeatherService,
  UserService,
  WeatherService,
  WeatherflowService,
  WundergroundService,
  apiClient,
};

export const SOURCE_SYNOP = 0;
export const SOURCE_NETATMO_WEATHER = 1;
export const SOURCE_DAVIS = 2;
export const SOURCE_WEATHERFLOW = 3;
export const SOURCE_AMBIENT_WEATHER = 4;
export const SOURCE_WUNDERGROUND = 5;
export const SOURCE_ECOWITT = 6;
export const SOURCE_MY_ACURITE = 7;

export const SUPPORTED_API_VERSION = 7;
const DEFAULT_URL_ROOT = 'https://api2.smartmixin.io';

let configuredUrlRoot: string | null = null;

/**
 * Configure the API URL at runtime.
 * Must be called before any API calls are made (typically at app startup).
 * If not called, defaults to production URL.
 */
export const configureApiUrl = (url: string) => {
  configuredUrlRoot = url;
};

/**
 * Get the current API URL.
 * Returns configured URL if set, otherwise the default production URL.
 */
export const getApiUrl = (): string => {
  return configuredUrlRoot ?? DEFAULT_URL_ROOT;
};

// Legacy export for backward compatibility
export const URL_ROOT = DEFAULT_URL_ROOT;
